<template>
  <LogoSvg class="w-auto" />
</template>

<script setup lang="ts">
// @ts-expect-error
import LogoSvg from '../../assets/logo.svg?component';
</script>
